import axios from '../utils/axios';

export default function postCompetitionEmail(adminId, data) {
    
    return (
        axios.post('/admin/'+adminId + '/competition/v2/competition/addCompetitionMailRequest', data)
    )
}
